import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as ACTION from '../constants/types/activityTypes';

import { stateStructure } from './_stateStructure.js'

const initialState = Immutable.fromJS(stateStructure.activity);

export default function activity(state = initialState, action) {

	let _state = state.toJS();

	switch (action.type) {
		// 获取活动列表
		case ACTION.GET_ACTIVITY_LIST: {
			if (action.result.data && action.result.data.length > 0) {
				_state.list = action.result.data.map((item) => _.merge(item, { type: 2, is_top: false, created_at: item.start_at }));
			} else {
				_state.list = [];
			}
			return state.merge(_state);
		}
		// 获取活动详情
		case ACTION.GET_ACTIVITY_DETAIL: {
			_state.detail = action.cleanData;
			return state.merge(_state);
		}
		// 销毁当前活动数据
		case ACTION.DISTROY_ACTIVITY_DETAIL: {
			_state.detail = null;
			return state.merge(_state);
		}
		// 注销用户
		case USER_ACTION.LOGOUT: {
			return initialState;
		}
		default:
			return state;
	}
}